import enLocale from 'element-ui/lib/locale/lang/en';
import { flatten } from 'flat';

const commons = {
    commons: {
        advertiser: 'advertiser | advertisers',
        approval: 'approval | approvals',
        banner: 'banner | banners',
        campaign: 'campaign | campaigns',
        dashboard: 'dashboard',
        offer: 'offer | offers',
        onboarding: 'onboarding | onboardings',
        report: 'report | reports',
        traffic_source: 'publisher | publishers',
        traffic_splitter: 'traffic splitter | traffic splitters',
        trigger: 'trigger | triggers',
        user: 'user | users',
        user_role: 'user role | user roles',
        advertiser_details: 'advertiser details',
        approval_details: 'approval details',
        campaign_details: 'campaign details',
        offer_details: 'offer details',
        onboarding_details: 'onboarding details',
        traffic_source_details: 'publisher details',
        smart_link_details: 'smart link details',
        trigger_details: 'trigger details',
        user_details: 'user details',
        user_role_details: 'user role details',
        basic_data: 'basic data',
        name: 'name',
        country: 'country | countries',
        traffic_type: 'traffic type',
        responsible: 'responsible',
        tracking_url: 'tracking URL | tracking URLs',
        proxyDetails: 'Proxy Details',
        taskDetails: 'Task Details',
        emailTemplateDetails: 'Email Template Details',
        status: {
            paused: 'paused',
            active: 'active',
            rejected: 'rejected',
            adjusted: 'adjusted',
            canceled: 'canceled',
        },
        actions: {
            edit: 'edit',
            activate: 'activate',
            pause: 'pause',
            save: 'save',
            reject: 'reject',
            cancel: 'cancel',
        },
        loggedOut: 'Logged Out',
        reason: 'reason',
    },
    loggedOut: 'Logged Out',
    accountSuspended: 'Your account is suspended',
    bulkActionsMsg: {
        pause: 'Are you sure you want to pause {count} {entity}(s)?',
        resume: 'Are you sure you want to resume {count} {entity}(s)?',
        approve: 'Are you sure you want to approve {count} {entity}(s)?',
        delete: 'Are you sure you want to delete {count} {entity}(s)?',
        pauseSuccess: '{count} {entity}(s) paused successfully',
        resumeSuccess: '{count} {entity}(s) resumed successfully',
        approveSuccess: '{count} {entity}(s) approved successfully',
        setLinksTracking: 'Select tracking that you want to set for {count} {entity}(s):',
        disableFraudProtection: 'Are you sure you want to disable Fraud Protection of {count} {entity}(s)?',
        enableFraudProtection: 'Are you sure you want to enable Fraud Protection of {count} {entity}(s)?',
        disableFraudProtectionSuccess: 'Fraud Protection of {count} {entity}(s) disabled successfully',
        enableFraudProtectionSuccess: 'Fraud Protection of {count} {entity}(s) enabled successfully',
        setLinksTrackingSuccess: 'Tracking of {count} {entity}(s) set successfully',
    },
    confirmModal: {
        actions: {
            disable: 'Are you sure you want to disable this {entity}?',
            reject: 'Are you sure you want to reject this {entity}?',
            pause: 'Are you sure you want to pause this {entity}?',
            activate: 'Are you sure you want to activate this {entity}?',
            approve: 'Are you sure you want to approve this {entity}?',
            deactivate: 'Are you sure you want to deactivate this {entity}?',
            retrieve: 'Are you sure you want to retrieve this {entity}?',
            delete: 'Are you sure you want to delete this {entity}?',
            setAsDefault: 'Are you sure you want to set this {entity} as default?',
            unsetAsDefault: 'Are you sure you want to unset this {entity} as default?',
            restoreDefaultValue: 'Are you sure you want to restore default value?',
        },
        saved: 'Changes have been saved!',
        processing: 'Your request is being handled by API. This may take a while...',
    },
    conversionDetails: {
        eventRejected: 'Conversion successfully rejected! This change will be applied to other reports within 30 minutes.',
        postbackRejected: 'Postback successfully rejected! The corresponding payout cancellation change will be applied to other reports within 30 minutes.',
    },
    trafficSources: {
        euVatTooltip: 'Set VAT Rate to 0% and mark this for Reverse Charge procedure',
    },
    targetingForm: {
        paramsTooltip: `Parameter Name and Value are available in the Click Url.
            Parameters are defined by the Publisher and are for example siteid=3, pageId=12 or affpubid=62891.`,
    },
    copyToClipboard: {
        tooltip: 'Click to copy to the clipboard',
        success: 'Copied to the clipboard.',
        error: 'Cannot copy to the clipboard.',
    },
    autoCaps: {
        calculationInProgress: 'It might take a while to adjust Auto (default) Caps on the Tracking Links level.',
    },
};


let dictionary = {
    ...enLocale,
    errorCodes: {
        NOT_FOUND_HTTP_EXCEPTION: 'Requested resource is not found',
        INVALID_CREDENTIALS: 'Invalid Credentials',
        UNKNOWN_PARAMETER: 'Requested data with unknown parameter',
    },
    validation: {
        messages: {
            required: () => {
                return 'Required';
            },
            email: () => {
                return 'This is not a valid email';
            },
            confirmed: () => {
                return 'Confirmation does not match';
            },
        },
    },
    list: {
        noDataMessage: 'No data',
        loadingError: 'Data loading failed. Please try again using Refresh button.',
        refresh: 'Refresh',
        noPreviewAvailable: 'No Preview Available',
    },
    urlChecker: {
        noIDProvided: 'No ID provided...',
        noResults: 'No results...',
        statuses: {
            confirmed: 'Confirmed',
            canceled: 'Canceled',
            warning: 'Warning',
            alert: 'Alert',
            ok: 'OK',
            none: '',
        },
    },
    developerTools: {
        title: 'Developer tools',
        privilegesManagement: {
            title: 'Privileges Management',
            noDataMessage: 'No privileges',
        },
    },
    banners: {
        incomplete: 'Incomplete',
    },
    emailTemplates: {
        settings: 'Settings',
        preview: 'Preview',
        edit: 'Edit Layout',
    },
    listImagePreview: {
        previewModalTitle: 'Preview',
    },
    tracking: {
        notIn: 'This name is reserved for system functionality and cannot be used as Event name. Please use another name or add a prefix/postfix to your proposed name.',
    },
    analytics: {
        manualAdjustment: {
            inProgress: 'Adjustment is being processed. Please wait, changes will be applied within few minutes.',
        },
    },
    ...flatten(commons),
};


// Override Element UI dictionary
dictionary.el.pagination = {
    ...enLocale.el.pagination,
    total: 'Total: {total}',
};

export default dictionary;
